<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="PUSH结果"
  >
    <div class="content" v-if="data">
      <div class="row" style="background-color: #e8eaec">
        <div class="name">域名</div>
        <div class="label">状态</div>
      </div>
      <div class="row" v-for="item in data" :key="item.domainName">
        <div class="name">{{ item.domainName }}</div>
        <div class="label">{{ item.relationStatus | statusFilter }}</div>
      </div>
    </div>
    <div class="foot">
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: "pushResultModal",
  filters: {
    statusFilter(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未处理";
          break;
        case 1:
          title = "处理中";
          break;
        case 2:
          title = "成功";
          break;
        case 3:
          title = "失败";
          break;
        default:
          break;
      }
      return title;
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
</style>
